import React from 'react';
import clsx from 'clsx';
import {useCart, Link, Image, useMoney} from '@shopify/hydrogen';
import {withCookies} from 'react-cookie';

//types
import type {ProductWithNodes} from '../../types';
import type {Cookies as CookiesType} from 'react-cookie';
import type {CurrencyCode as CurrencyCodeType} from '@shopify/hydrogen/storefront-api-types';

//utils
import formatCurrency from '../../utils/formatCurrency.client';

//context
import {GlobalContext} from '../../GlobalProvider.client';

interface Props {
  frequentlyBoughtTogetherProducts: ProductWithNodes[] | null;
  type?: string;
  title: string | undefined | null;
  button_label: string | undefined | null;
  total_price_label: string | undefined | null;
  cookies: CookiesType;
}

function FrequentlyBoughtTogether({
  frequentlyBoughtTogetherProducts,
  type,
  title,
  button_label,
  total_price_label,
  cookies,
}: Props) {
  const firstTwoAvailableProducts =
    frequentlyBoughtTogetherProducts &&
    frequentlyBoughtTogetherProducts
      .filter((p) => p.availableForSale)
      .filter((_, index) => index < 2);

  const firstAvailableProducts =
    frequentlyBoughtTogetherProducts &&
    frequentlyBoughtTogetherProducts
      .filter((p) => p.availableForSale)
      .filter((_, index) => index < 1);

  const currency = React.useContext(GlobalContext);
  const selectedCurrency =
    (cookies.get('hk-currency') as CurrencyCodeType) ??
    ('HKD' as CurrencyCodeType);

  const selectedCurrencyDetails = currency?.all_currencies?.find(
    (c) => c.currency === selectedCurrency,
  );

  const firstFBTProductPrice =
    firstTwoAvailableProducts &&
    firstTwoAvailableProducts[0].variants.nodes[0].priceV2.amount;
  // const secondFBTProductPrice =
  //   firstTwoAvailableProducts &&
  //   firstTwoAvailableProducts[1].variants.nodes[0].priceV2.amount;

  const firstAvailableProductPrice =
    firstFBTProductPrice &&
    ((parseFloat(firstFBTProductPrice) * 100) / 100).toFixed(2);
  const firstAvailableProductPriceFormatted = firstAvailableProductPrice && formatCurrency({
    currencyCode: selectedCurrency,
    amount: firstAvailableProductPrice,
  });

  // const totalPrice =
  //   firstFBTProductPrice &&
  //   secondFBTProductPrice &&
  //   (
  //     (parseFloat(firstFBTProductPrice) * 100 +
  //       parseFloat(secondFBTProductPrice) * 100) /
  //     100
  //   ).toFixed(2);

  const {linesAdd, status} = useCart();
  const handleAddItem = React.useCallback(() => {
    const itemsToAdd = firstTwoAvailableProducts
      ?.filter((_, i) => i < 2)
      ?.map((p) => ({
        quantity: 1,
        merchandiseId:
          p?.variants?.nodes?.find((v) => v.availableForSale)?.id ?? '',
      }));
    itemsToAdd && status === 'idle' && linesAdd([...itemsToAdd]);
  }, [linesAdd, frequentlyBoughtTogetherProducts]);

  // const totalPriceFormatted =
  //   totalPrice &&
  //   formatCurrency({
  //     currencyCode: selectedCurrency,
  //     amount: totalPrice,
  //   });

  return (
    <div className="frequently-bought-together">
      <h4 className="mb-[20px] text-[22px] font-medium">
        {title ?? 'Freguently Bought Together'}
      </h4>
      <div className={clsx(type === 'cart' && 'grid gap-8 md:grid-cols-2')}>
        <div className="relative">
          {/* <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.39227 0.401998V8.648H0.336274V11.574H8.39227V19.782H11.6223V11.574H19.7163V8.648H11.6223V0.401998H8.39227Z"
                fill="black"
              />
            </svg>
          </div> */}
          <div className="mb-[28px] grid">
            {firstAvailableProducts &&
              firstAvailableProducts.map((p) => {
                const firstAvailableVariant = p.variants.nodes.find(
                  (v) => v.availableForSale,
                );
                return (
                  <Link
                    key={p.id}
                    to={`/products/${
                      p.handle
                    }?v=${firstAvailableVariant?.id?.replace(
                      'gid://shopify/ProductVariant/',
                      '',
                    )}`}
                    title={firstAvailableVariant?.title}
                  >
                    <div className="aspect-w-16 aspect-h-16 overflow-hidden border border-slate-100 shadow-md transition-all duration-200 ease-out group-hover:shadow-lg">
                      <div className="p-4 transition-transform duration-200 ease-out group-hover:scale-110">
                        {firstAvailableVariant?.image && (
                          <Image
                            className="flex h-full shrink-0 grow-0 select-none object-contain"
                            data={firstAvailableVariant?.image}
                          />
                        )}
                      </div>
                    </div>
                  </Link>
                );
              })}
            {/* {firstTwoAvailableProducts &&
              firstTwoAvailableProducts.map((p) => {
                const firstAvailableVariant = p.variants.nodes.find(
                  (v) => v.availableForSale,
                );
                return (
                  <div
                    key={p.id}
                    className="aspect-w-16 aspect-h-16 overflow-hidden border border-slate-100 shadow-md transition-all duration-200 ease-out group-hover:shadow-lg"
                  >
                    <Link
                      to={`/products/${
                        p.handle
                      }?v=${firstAvailableVariant?.id?.replace(
                        'gid://shopify/ProductVariant/',
                        '',
                      )}`}
                      title={firstAvailableVariant?.title}
                    >
                      <div className="p-4 transition-transform duration-200 ease-out group-hover:scale-110">
                        {firstAvailableVariant?.image && (
                          <Image
                            className="flex shrink-0 grow-0 select-none object-contain"
                            data={firstAvailableVariant?.image}
                          />
                        )}
                      </div>
                    </Link>
                  </div>
                );
              })} */}
          </div>
        </div>
        <div className="">
          <div className="mb-5 flex items-center space-x-1 text-[20px]">
            <div className="">{total_price_label ?? 'Total Price'}: </div>
            <div className="font-semibold text-hk-orange">
              {/* $HK{' '}
              {totalFBTPrice && typeof totalFBTPrice === 'number'
                ? totalFBTPrice.toFixed(2)
                : ''}{' '}
              HKD */}
              {selectedCurrencyDetails?.details?.currency?.code}
              {firstAvailableProductPriceFormatted && firstAvailableProductPriceFormatted?.toFixed(2)}
            </div>
          </div>
          <div className="">
            <button
              onClick={handleAddItem}
              className={clsx([
                'w-full bg-black py-3 text-[20px] font-normal uppercase text-hk-orange transition-all duration-200 ease-out hover:bg-hk-orange hover:text-black',
              ])}
            >
              {button_label ?? 'ADD SELECTED TO CART'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withCookies(FrequentlyBoughtTogether);
